var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.882 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C7.1 33.453.795 27.143.795 19.365.795 11.587 7.1 5.28 14.882 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.796 13.281a5.599 5.599 0 0 1 5.491 3.745h.344a3.725 3.725 0 0 1 1.78 6.995.6.6 0 1 1-.574-1.053 2.524 2.524 0 0 0-1.207-4.742h-.787a.6.6 0 0 1-.58-.45 4.4 4.4 0 1 0-7.558 4.015.6.6 0 1 1-.899.795 5.6 5.6 0 0 1 3.99-9.305Zm1.66 5.796a.6.6 0 0 1 .849 0l2.5 2.5a.6.6 0 1 1-.849.848l-1.475-1.476v4.177a.6.6 0 0 1-1.2 0v-4.177l-1.476 1.476a.6.6 0 0 1-.849-.848l2.5-2.5Z",
    fill: "#0086C9"
  })));
};

export default SvgUpload;